import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';

export type LogoutUseCase = UseCase<void, void>;

export function logoutBuilder(authRepository: AuthRepository): LogoutUseCase {
	return async function logout(): Promise<void> {
		return authRepository.logout();
	};
}
